module.exports = __webpack_public_path__ + "static/media/Blue_Box_with_a_Cup.3f7e1111.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Blue_Box_with_a_Cup.png
// module id = 1571
// module chunks = 0